<app-landing-header></app-landing-header>
<div class="container-fluid">
  <div class="row">
    <div
      class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app-landing-container d-flex justify-content-center"
    >
      <app-welcome-details></app-welcome-details>
    </div>

    <div
      class="col-xs-12 col-sm-5 col-md-5 col-lg-5 app-confirm-password-form mx-auto"
    >
      <div class="container">
        <div class="m-4">&nbsp;</div>
        <div class="m-4">&nbsp;</div>
        <div class="m-4">&nbsp;</div>

        <h1 class="font-weight-bold text-left">
          <i class="fas fa-lock iconic"></i> &nbsp;&nbsp; Create a new Password
        </h1>
        <div class="m-2">&nbsp;</div>

        <h4>Use at least 8 characters, don't use passwords from other sites.</h4>
        <div class="m-1">&nbsp;</div>

        <div *ngIf="message" class="alert" [ngClass]="serverError ? 'alert-danger' :  'alert-success'">
          {{ message }}
          <a routerLink="/" *ngIf="!serverError"> <br /> You can Login to your Account</a>
        </div>
        <form (ngSubmit)="onSubmit()" [formGroup]="confirmPassword" *ngIf="validToken">
            <div *ngIf="newPassword.hasError('minlength')" class="alert alert-danger default-size">
                * Password must be at least 8 characters long.
            </div>
            <div *ngIf="!(newPassword.value === newPassword2.value)"class="alert alert-danger default-size">
               * Password does not match
            </div>
          <div class="form-group">
            <input
              type="password"
              class="form-control"
              formControlName="newPassword"
              id="newPassword"
              aria-describedby="newPasswordHelp"
              placeholder="Enter Password"
            />
          </div>
          <div class="form-group">
            <input
              type="password"
              formControlName="newPassword2"
              class="form-control"
              id="newPassword2"
              aria-describedby="newPassword2Help"
              placeholder="Re-enter Password Again"
            />
          </div>

          <button type="submit" class="btn login-btn " [disabled]="!confirmPassword.valid">

              <span class="spinner-border" *ngIf="loading" role="status" aria-hidden="true"></span>

            Change Password
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
